module.exports = __webpack_public_path__ + "media/Burruss Hall.829b9c94.mp3";